export const GLOBAL_GENERIC_LABELS = 'global.generic';
export const lblDetails = `lbl_details`;
export const lblOr = `lbl_or`;
export const lblMyBag = `lbl_myBag`;
export const lblGiftCards = `lbl_gift_cards`;
export const lblDesign = `lbl_design`;
export const lblShopNow = `lbl_shop_now`;
export const lblBonus = `lbl_bonus`;
export const lblRewardPointsCaps = `lbl_reward_points_caps`;
export const lblRewardPoints = `lbl_reward_points`;
export const lblUpdate = `lbl_update`;
export const lblUpdateCaps = `lbl_update_caps`;
export const lblValue = `lbl_value`;
export const lblContinueShopping = `lbl_continue_shopping`;
export const lblCurrency = `lbl_currency`;
export const lblShipping = `lbl_shipping`;
export const lblFirstName = `lbl_firstName`;
export const lblLastName = `lbl_lastName`;
export const lblEmailAddress = `lbl_emailAddress`;
export const lblPageVisibilityMsg = `lbl_pageVisibility_msg`;
export const lblTnc = `lbl_tnc`;
export const lblZipCode = `lbl_zipCode`;
export const lblBack = `lbl_back`;
export const lblLearnMore = `lbl_learnMore`;
export const lblCreateAccount = `lbl_createAccount`;
export const lblLogin = `lbl_login`;
export const lblCreditCard = `lbl_creditCard`;
export const lblPhoneNumber = `lbl_phone_no`;
export const lblGym = `lbl_gym`;
export const lblPjp = `lbl_pjp`;
export const lblProgramDetails = `lbl_program_details`;
export const lblTcp = `lbl_tcp`;
export const lblPassword = `lbl_password`;
export const lblPickup = `lbl_pickup`;
export const lblSnj = `lbl_snj`;
export const lblOrderNumber = `lbl_orderNumber`;
export const lblItems = `lbl_items`;
export const lblBuyOnlinePickupInStore = `lbl_buy_online_pickup_in_store`;
export const lblSizeChartHeader = `lbl_size_chart_header`;
export const lblSizeChartInformation = `lbl_size_chart_information`;
export const lblSizeChartDepartmentHeader = `lbl_size_chart_department_header`;
export const lblSizeChartCategoryHeader = `lbl_size_chart_category_header`;
export const lblSizeChartUs = `lbl_size_chart_us`;
export const lblSizeChartMetric = `lbl_size_chart_metric`;
export const lblCountdownDays = `lbl_countdown_Days`;
export const lblCountdownHours = `lbl_countdown_Hours`;
export const lblCountdownMinutes = `lbl_countdown_Minutes`;
export const lblCountdownSeconds = `lbl_countdown_Seconds`;
export const lblColors = `lbl_colors`;
export const lblSiteCookiesDisclaimer = `lbl_site_cookies_disclaimer`;
export const lblTabNoProductsFoundMsg = `lbl_tab_no_products_found_msg`;

export const GlobalGenericLabels = {
  global: {
    generic: {
      [lblDetails]: 'Details',
      [lblOr]: 'or',
      [lblMyBag]: 'My Bag',
      [lblGiftCards]: 'Gift Cards',
      [lblDesign]: 'Design',
      [lblShopNow]: 'SHOP NOW',
      [lblBonus]: 'BONUS',
      [lblRewardPointsCaps]: 'POINTS',
      [lblRewardPoints]: 'Points',
      [lblUpdate]: 'Update',
      [lblUpdateCaps]: 'UPDATE',
      [lblValue]: 'Value',
      [lblContinueShopping]: 'Continue Shopping',
      [lblCurrency]: '$',
      [lblShipping]: 'Shipping',
      [lblFirstName]: 'First Name',
      [lblLastName]: 'Last Name',
      [lblEmailAddress]: 'Email Address',
      [lblPageVisibilityMsg]: 'Refreshing for the latest deals!',
      [lblTnc]: 'Terms & Conditions',
      [lblZipCode]: 'Zip Code',
      [lblBack]: 'Back',
      [lblLearnMore]: 'Learn More',
      [lblCreateAccount]: 'Create Account',
      [lblLogin]: 'Log In',
      [lblCreditCard]: 'Credit Card',
      [lblPhoneNumber]: 'Phone Number',
      [lblGym]: 'Gymboree',
      [lblPjp]: 'PJ Place',
      [lblProgramDetails]: 'Program Details',
      [lblTcp]: 'The Children’s Place',
      [lblPassword]: 'Password',
      [lblPickup]: 'Pickup',
      [lblSnj]: 'Sugar & Jade',
      [lblOrderNumber]: 'Order Number',
      [lblItems]: 'Items',
      [lblBuyOnlinePickupInStore]: 'BUY ONLINE, PICK UP IN STORE',
      [lblSizeChartHeader]: 'Size Chart',
      [lblSizeChartInformation]: 'SIZE INFORMATION',
      [lblSizeChartDepartmentHeader]: 'Departments',
      [lblSizeChartCategoryHeader]: 'Category',
      [lblSizeChartUs]: 'US',
      [lblSizeChartMetric]: 'Metric',
      [lblCountdownDays]: 'DAYS',
      [lblCountdownHours]: 'HOURS',
      [lblCountdownMinutes]: 'MINUTES',
      [lblCountdownSeconds]: 'SECONDS',
      [lblTabNoProductsFoundMsg]: 'Unable to fetch Products',
      [lblColors]: 'Colors',
      [lblSiteCookiesDisclaimer]:
        'This website uses cookies to better understand how visitors use our site, for advertising, and to offer you a more personalized experience. We share information about your use of our site with analytics, social media, and advertising partners in accordance with our Privacy Statement and California Privacy Notice. By continuing to use this website you are consenting to this use.',
    },
  },
};
